import common from '@/store/common/mutations';
import * as types from './mutation-types';
import { SEARCH_PARAMS, GROUPS } from './state';

export default {
	...common,
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.groups = GROUPS();
		state.asPartInfo = [];
		state.gridList = [];
		state.useYnList = []; // PWAYN 콤보박스 리스트
		state.opCdList = []; // op코드 콤보박스 리스트
		state.cmpnDisabled = false;
	},
	[types.STATE_CLEAR]: state => {
		state.gridList[key] = value;
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.GROUPS]: (state, { key, value }) => {
		state.groups[key] = value;
	},
	[types.SEARCH_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
	}
};
